export default __webpack_public_path__ + "static/media/jms-infusion.b2b82888.jpg";